export default "assets/images/queue-home1-963eb52a.png";